import {ReportModel} from "@fedeltapointofsale/data-client";
import {ExtrasSoldReportData} from "./extras-sold-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ExtrasSoldReportModel extends ReportModel<ExtrasSoldReportData> {
    constructor(injector: Injector) {
        super(injector, ExtrasSoldReportData)
    }
}
